import { CUSTOMER_SELECTABLE_ORDER_TYPES } from '~/constants/search'
import { isOrderType, type OrderType } from '~/enums'

/** Whether a raw value (form, URL, cookie) names an order type the customer interface offers. */
export const isCustomerSelectableOrderType = (value: unknown): value is OrderType =>
  isOrderType(value) && CUSTOMER_SELECTABLE_ORDER_TYPES.includes(value)
